<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="50%"
      :before-close="handleClose"
    >


      <el-descriptions title="账号信息" :column="2" border size="small">
        <el-descriptions-item label="门店编号：">{{formData.sn}}</el-descriptions-item>
        <el-descriptions-item label="门店名称：">{{formData.name}}</el-descriptions-item>

        <el-descriptions-item label="所属代理商">{{formData.proxy?formData.proxy.username:''}}</el-descriptions-item>
        <el-descriptions-item label="所属渠道">{{formData.companyuser?formData.companyuser.real_name:''}}</el-descriptions-item>
        <el-descriptions-item label="联系人姓名">{{formData.cont_name}}</el-descriptions-item>
        <el-descriptions-item label="手机号：">{{formData.mobile}}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{formData.province?formData.province.region_name:''}}
          {{formData.city?formData.city.region_name:''}}
          {{formData.district?formData.district.region_name:''}}
        </el-descriptions-item>
        <el-descriptions-item label="详细地址：">{{formData.address}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{dateFormat(formData.add_time)}}</el-descriptions-item>

        <el-descriptions-item label="状态">{{formData.status==1?'启用':'禁用'}}</el-descriptions-item>
        <el-descriptions-item label="门店类型">{{formData.type==1?'总部':'分部'}}</el-descriptions-item>
        <el-descriptions-item label="终端产品">{{formData.posbrand?formData.posbrand.name:''}}</el-descriptions-item>
      </el-descriptions>
      <!--      <el-divider content-position="left">关联商户信息</el-divider>-->
      <el-descriptions title="关联商户信息" :column="2" border size="small">
        <el-descriptions-item label="商户编号：">{{formData.member?formData.member.sn:''}}</el-descriptions-item>
        <el-descriptions-item label="商户名称：">{{formData.member?formData.member.merchant_name:''}}</el-descriptions-item>
        <el-descriptions-item label="商户简称">{{formData.member?formData.member.short_name:''}}</el-descriptions-item>
        <el-descriptions-item label="启用通道">通联支付</el-descriptions-item>
      </el-descriptions>

    </el-dialog>
  </div>
</template>
<script>

  import moment from "moment";

  export default {
    name:'eShopUser',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data(){
      return {
        localVisible:false,
        memberList:[],
        rules: {
          title: [
            { required: true, message: "请输入标题", trigger: "blur" },
            { min: 2, max: 30, message: "请控制在2-30个字符", trigger: "blur" },
          ]
        },
        curShop:'',
        employee_id:'',
        name_cn:'',

        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {
      //this.getList();
    },
    methods:{
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      // 关闭
      handleClose() {
        //  this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let _this=this;
        let param={
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          name:this.formData.name,
          mobile:this.formData.mobile,
        }
        if(this.formData.id){
          param.id=this.formData.id;
          this.$axios.shopUserSave(param).then(res=>{
            if(res.code == 200){
              this.$message.success("修改成功");
              _this.handleClose();
            }
          }).catch(error=>{
            console.log(error);
          })

        }else{
          this.$axios.shopUserSave(param).then(res=>{
            if(res.code == 200){
              this.$message.success("保存成功");
              _this.handleClose();
            }
          }).catch(error=>{
            console.log(error);
          })
        }
      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        if (val) {
          this.localVisible=val;
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
